import React from "react";
import PropTypes from "prop-types";
import {Input} from "reactstrap";
import {isNil} from "lodash";

InputNumber.defaultProps = {
  autoFocus: true,
  size: 'sm',
};

InputNumber.propTypes = {
  size: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default function InputNumber(props) {
  const [value, setValue] = React.useState(!isNil(props.value) ? parseInt(props.value) : null);

  const onChange = (value) => {
    props.onChange(parseInt(value))
  };

  return <Input
    bsSize={props.size}
    className={props.className}
    autoFocus={props.autoFocus}
    onFocus={e => e.target.select()}
    onBlur={() => onChange(value)}
    value={value}
    placeholder={props.placeholder}
    onChange={e => {
      let v = e.target.value.replace(',', '.');

      if (v === '' || /^\d*$/.test(v)) {
        setValue(v);
      }
    }}
    onKeyUp={e => {
      if(e.key === 'Enter') {
        onChange(value)
      }else if(e.key === 'Escape') {
        onChange(props.value)
      }
    }}
  />
};
